import { render } from "./RenameVODFolderModal.vue?vue&type=template&id=c961c08a"
import script from "./RenameVODFolderModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RenameVODFolderModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/RenameVODFolderModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c961c08a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c961c08a', __exports__)) {
    api.reload('c961c08a', __exports__)
  }
  
  module.hot.accept("./RenameVODFolderModal.vue?vue&type=template&id=c961c08a", () => {
    api.rerender('c961c08a', render)
  })

}


export default __exports__